import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RecordsTable from '../records_table/records_table';
import { getMeta } from '../store/run_records_selectors';

export function Records({
  currentPage,
  pageSize,
  totalCount,
}) {
  const renderPageTitle = () => {
    const startIndex = ((currentPage - 1) * pageSize) + 1;
    let endingIndex = currentPage * pageSize;

    endingIndex = endingIndex > totalCount ? totalCount : endingIndex;

    return (
      <div className="h4 mt-5">
        Displaying {startIndex}-{endingIndex} of {totalCount} records
      </div>
    );
  };

  return (
    <React.Fragment>
      {renderPageTitle()}
      <RecordsTable />
    </React.Fragment>
  );
}

Records.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  ...getMeta(state),
});

export default connect(mapStateToProps)(Records);